import globalReducer from './global';
import sortingReducer from './volunteersService';

export { globalReducer, sortingReducer };
